
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import PaymentMeans from '@/extend/classes/PaymentMeans';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storePaymentMeans' })

export default class storePaymentMeans extends VuexModule {
  // States
  private reccords: PaymentMeans[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get paymentMeansLoading (): boolean {
    return this.dataLoading;
  }
  private get paymentMeansRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get paymentMeansLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewPaymentMeans() {
    return (): PaymentMeans => { 
      return this.getPaymentMeans(0, true);
    }
  }

  
  public get getPaymentMeans () {
    return (id: number, canCreate = false): PaymentMeans => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id PaymentMeans can't be 0")
        return new PaymentMeans();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new PaymentMeans();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            PaymentMeans.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromPaymentMeans(data.reccords[0] as PaymentMeans);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listPaymentMeans (): PaymentMeans[] {
    return this.reccords;
  }

  public get listConfigPaymentMeans (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mPaymentMeansRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mPaymentMeansClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mPaymentMeansLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mPaymentMeansLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(PaymentMeans.fromJson(reccord as PaymentMeans));
    })
    PaymentMeans.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mPaymentMeansConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mPaymentMeansCreated (obj: PaymentMeans): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.comparePaymentMeans(obj)) {
          api.fromPaymentMeans(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.comparePaymentMeans(obj)) {
            api.fromPaymentMeans(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mPaymentMeansUpdated (obj: PaymentMeans): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.comparePaymentMeans(obj)) {
          api.fromPaymentMeans(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mPaymentMeansDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerPaymentMeans (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.paymentMeansRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerPaymentMeans(this.paymentMeansCreated, this.paymentMeansUpdated, this.paymentMeansDeleted);
          this.mPaymentMeansRegistered();
        } else {
          setTimeout(() => resolve(this.registerPaymentMeans(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.paymentMeansLoading && !this.paymentMeansLoaded) {
          this.mPaymentMeansLoading(true);
          return PaymentMeans.list(filter)
            .then((data: ListData) => {
              this.mPaymentMeansLoaded(data);
              this.mPaymentMeansLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredPaymentMeans (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.paymentMeansLoading) {
        this.mPaymentMeansLoading(true);
        return PaymentMeans.list(filter)
          .then((data: ListData) => {
            this.mPaymentMeansLoaded(data);
            this.mPaymentMeansLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createPaymentMeans (obj: PaymentMeans): Promise<PaymentMeans> {
    return new Promise((resolve, reject) => {
      return PaymentMeans.fromJson(obj).createForStorePaymentMeans()
        .then((reccords) => {
          this.mPaymentMeansCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updatePaymentMeans (obj: PaymentMeans): Promise<PaymentMeans> {
    return new Promise((resolve, reject) => {
      return PaymentMeans.fromJson(obj).updateForStorePaymentMeans()
        .then((reccords) => {
          this.mPaymentMeansUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deletePaymentMeans (obj: PaymentMeans): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return PaymentMeans.fromJson(obj).deleteForStorePaymentMeans()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mPaymentMeansDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private paymentMeansCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mPaymentMeansConfigUpdated(config)
    const obj = objConfig.obj as PaymentMeans;
    this.mPaymentMeansCreated(PaymentMeans.fromJson(obj));
  }

  @Action
  private paymentMeansUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mPaymentMeansConfigUpdated(config)
    const obj = objConfig.obj as PaymentMeans;
    this.mPaymentMeansUpdated(PaymentMeans.fromJson(obj));
  }

  @Action
  private paymentMeansDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as PaymentMeans;
    this.mPaymentMeansDeleted(obj.id);
  }
}
